import React from "react";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  FabricStylePurchaseHistoryCriteriaBean,
  FabricStylePurchaseOrderHistoryPrintRequest,
} from "../ds/ds.js";
import { ShowError, ColumnDefinition } from "../gui_components/UIComponents.js";
import { isEmptyArray, isEmptyString, } from "../gui_components/Util";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class VendorPurchaseHistory extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Vendor Purchase History Inquiry",
      isShowCriteriaView: true,
      isShowPopup: false,
      inquiryDataList: [],
      criteria: new FabricStylePurchaseHistoryCriteriaBean(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      error_list: [],
      is3PL: false,
   
    };
    this.fabricStyleCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    if (this.props.vendorCode !== "" && this.props.vendorCode !== undefined) {
      let temp_Criteria = this.state.criteria;
      temp_Criteria.vendorCode = this.props.vendorCode;
      this.setState({
        criteria: temp_Criteria,
        isShowCriteriaView: false,
        isShowResetButton: false,
        isShowExecuteButton: false,
        isShowClearCriteriaButton: false,
      });
      this.loadPage();
    }
  }
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ errorList: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.loadFabricStylePurchaseHistoryList(criteria);
  };
  loadFabricStylePurchaseHistoryList = (criteria) => {
    ReportService.inquireFabricStylePurchaseOrderHistoryInfos(
      criteria,
      this.loadFabricStylePurchaseHistoryPageResponse,
      this.errorCallBack
    );
  };
  loadFabricStylePurchaseHistoryPageResponse = (response) => {
    if (response.data != null && response.data.result != null) {
      let inquiryDataList = [];
      if (!isEmptyArray(response.data.result.historyBeans)) {
        inquiryDataList = response.data.result.historyBeans;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        inquiryDataList: inquiryDataList,
      });
    }
  };
  generateExcel = () => {
    this.downloadReport(2, this.state.criteria);
  };
  generatePDF = () => {
    this.downloadReport(1, this.state.criteria);
  };
  downloadReportResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  downloadReport = (reportType, criteria) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let requestInput = new FabricStylePurchaseOrderHistoryPrintRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.criteria = criteria;
    requestInput.reportBean = reportBean;
    ReportService.generateFabricStylePurchaseOrderHistoryPrintReport(
      requestInput,
      this.downloadReportResponse,
      this.errorCallBack
    );
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Vendor#",
          "vendorCode",
          true
        )
        .setStyleDetails("left", "6", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "VendorName",
          "vendorName",
          true
        )
        .setStyleDetails("left", "8", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO.Date", "purchaseOrderDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item" : "Fabric",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item Name" : "FabricStyle Name",
          "fabricStyleName",
          true
        )
        .setStyleDetails("left", "8", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColor", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PurchaseOrderQty", "purchaseOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("P.O.RcvdQty", "purchaseOrderReceivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let is3PL = this.state.is3PL;
    return (
      <div>
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <div className="mt-3">
          <CustomTable
            data={inquiryDataList}
            columns={this.inquiryColumns()}
          />
        </div>
      </div>
    );
  }
}
function VendorPurchaseHistoryInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <VendorPurchaseHistory {...props} name="" /> <br />
    </div>
  );
}

export default VendorPurchaseHistoryInquiry;
